import { AboutUs } from "../pages/AboutUs";

export default function AboutUsRoute() {
	return <AboutUs />;
}
